<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
      <div class="flex flex-align-center">
          <a routerLink="/button" aria-label="back"
              class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
              <span class="u-icon icon-chevron-left"></span>
              <span class="u-btn-text">Back</span>
          </a>
      </div>
      <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
          <h1 class="font-semibold u-ma-0 flex header-title--name">Glossary Player</h1>
      </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
  <div class="content content--modifier-height">
    
    <h1>Player Use Case 1: Audio Type mp3</h1>
    <maced-player [showDefaultPlayer]="showDefaultPlayer" [id]="id1" [audioUrl]="audioUrl1"></maced-player>
    
    <h1>Player Use Case 2: Audio Type wav</h1>
    <maced-player [showDefaultPlayer]="showDefaultPlayer" [id]="id2" [audioUrl]="audioUrl2"></maced-player>
    
    <h1>Player Use Case 3: Audio Type Ogg</h1>
    <maced-player [showDefaultPlayer]="showDefaultPlayer" [id]="id3" [audioUrl]="audioUrl3"></maced-player>
    
    <h1>Player Use Case 4: Disabled State</h1>
    <maced-player [showDefaultPlayer]="showDefaultPlayer" [id]="id4"  [isDisabled]="true" [audioUrl]="audioUrl1"></maced-player>
    <br>
  </div>